import {useEffect} from "react"
import usePermissions from "../hooks/usePermissions"
import Section from "../components/Section"
import SectionHeader from "../components/SectionHeader"
import SectionContent from "../components/SectionContent"
import List from "../components/List"

export default function Messages(){

    const {restrictSection}=usePermissions()
    useEffect(()=>{
        restrictSection("master","")
    },[])
    
    return(
        <Section>
            <SectionHeader
                title="Mensajes"
                intro="Mensajes enviados desde la página promocional."
                back=""
                button=""
                tabs={[
                    {label:"Mensajes",to:"/c24/mensajes"}
                ]}
            />
            <SectionContent>
                <List config={{
                    section:"messages",
                    endpoint:"messages/list",
                    limit:100,
                    counter:{
                        singular:"mensaje",
                        plural:"mensajes"
                    },
                    action:{
                        mode:"modal",
                        context:"",
                        reference:"message-info"
                    }
                }} />
            </SectionContent>
        </Section>
    )
    
}